import React, { lazy, Suspense } from "react";
import { useRoutes } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import BackupDownloadComponent from "../Component/Download";
import StudentAttendance from "../Component/Academic/Students/StudentAttendance";
//import Inventory from "../Component/Admin/Inventory/Inventory";
//import Inventory from "../Component/Admin/Store/AdminPage";
import AdminPage from "../Component/Admin/Store/AdminPage";
import StockManagementPage from "../Component/Admin/Store/StockManagement";
import Purchase from "../Component/Admin/Store/Purchase/Purchase";
import Suppliers from "../Component/Admin/Store/Suppliers";
import Consumption from "../Component/Admin/Store/Consumption";
import PurchaseReturns from "../Component/Admin/Store/Purchase/PurchaseReturns";
import WelcomeLetter from "../Component/Academic/Students/WelcomeLetter";

import AdminLayout from "../Component/Library/Admin/AdminLayout";
import Journal from "../Component/Accounts/Journal";
import LettersComponent from "../Component/Admin/Letters/LettersComponent";
import RegisterFace from "../Component/Attendance/RegisterFace";
import AttendanceCamera from "../Component/Attendance/AttendanceCamera";
import LivenessSettingsAdmin from "../Component/Attendance/LivenessSettingsAdmin";
import ManualAttendanceForm from "../Component/Attendance/ManualAttendanceorm";

const QRCodeGenerator = lazy(
  () => import("../Component/Admin/QRCode/QrCodeGenerator"),
);
const EmployeesAttendanceList = lazy(
  () => import("../Component/Employees/EmployeesAttendanceList"),
);
const UtilityManagement = lazy(
  () => import("../Component/Admin/UtilityManagement"),
);

const CallLogEntry = lazy(() => import("../Component/Enquiry/CallLogEntry"));
const FeeSummary = lazy(() => import("../Component/Students/FeeSummary"));
const AdminIDCard = lazy(() => import("../Component/Admin/IDCard/AdminIDCard"));
const IDCard = lazy(() => import("../Component/Admin/IDCard/IDCard"));
const SupportPanel = lazy(() => import("../Component/Support/SupportPanel"));
const ReportInfo = lazy(
  () => import("../Component/Academic/Students/ReportingInfo"),
);
const HostelForm = lazy(() => import("../Component/HR/HeadCount"));
const AdminPageLibrary = lazy(
  () => import("../Component/Library/Admin/LibraryDashboard"),
);

const AdminBooksPage = lazy(
  () => import("../Component/Library/Admin/AdminBooksPage"),
);
const BooksRentalList = lazy(
  () => import("../Component/Library/Admin/BooksRentalList"),
);
// Lazy-loaded components
//import Login from "../Components/View/Authentication/Login";
//import CRM from "../Components/View/CRM/CRM";

const Unauthorized = lazy(() => import("./Unauthorized"));
const Home = lazy(() => import("../Component/Home/Home"));
const PaySlipList = lazy(() => import("../Component/Accounts/PaySlipList"));
const StudentAttendanceList = lazy(
  () => import("../Component/Academic/Students/StudentAttendanceList"),
);
const TeacherDashboard = lazy(
  () => import("../Component/Dashboard/TeacherDashboard"),
);

const FeesStructureList = lazy(
  () => import("../Component/Accounts/FeesStructureList"),
);
const EmployeeList = lazy(() => import("../Component/Employees/EmployeeList"));
const InvoiceList = lazy(() => import("../Component/Accounts/InvoiceList"));
const Login = lazy(() => import("../Component/Auth/Login"));
const OfficeAutomationDashboard = lazy(
  () => import("../Component/Home/OfficeAutomationDashboard"),
);

const EmployeeManagement = lazy(
  () => import("../Component/Employees/EmployeeManagement"),
);
const LeaveManagement = lazy(
  () => import("../Component/Employees/LeaveManagent"),
);
const PayrollProcessing = lazy(
  () => import("../Component/Accounts/PayrollProcessing"),
);
const PaySlip = lazy(() => import("../Component/Accounts/PaySlip"));
const AttendanceForm = lazy(
  () => import("../Component/Employees/Attendance/AttendanceForm"),
);
const ChairmanDashboard = lazy(
  () => import("../Component/Dashboard/ChairmanDashboard"),
);
const EnquiryForm = lazy(() => import("../Component/Enquiry/EnquiryForm"));
const AdmissionForm = lazy(
  () => import("../Component/Admission/AdmissionForm"),
);
 
const TrashAdmissions = lazy(
  () => import("../Component/Students/TrashAdmissionsList")
);
const StudentTrashDetails = lazy(
  () => import("../Component/Students/StudentTrashDetails")
);
const FeeReceipt = lazy(() => import("../Component/Accounts/FeeReceipt"));
const StudentList = lazy(() => import("../Component/Students/StudentList"));
const PrincipalDashboard = lazy(
  () => import("../Component/Dashboard/PrincipalDashboard"),
);
const ViewReports = lazy(() => import("../Component/Academic/ViewReports"));
const EventScheduler = lazy(
  () => import("../Component/Academic/EventScheduler"),
);
const SmsAlerts = lazy(() => import("../Component/Academic/SmsAlerts"));
const HostelManagement = lazy(
  () => import("../Component/Admin/HostelManagement"),
);
const AccountsManagement = lazy(
  () => import("../Component/Accounts/AccountsManagement"),
);
const LetterGenerator = lazy(
  () => import("../Component/Admin/LetterGenerator"),
);
const CertificateGenerator = lazy(
  () => import("../Component/Admin/CertificateGenerator"),
);
const AdminDashboard = lazy(
  () => import("../Component/Dashboard/AdminDashboard"),
);
const AccountsDashboard = lazy(
  () => import("../Component/Dashboard/AccountsDashboard"),
);
const FeesManagement = lazy(
  () => import("../Component/Accounts/FeesManagement"),
);
const GenerateInvoice = lazy(
  () => import("../Component/Accounts/GenerateInvoice"),
);
const FeesStructure = lazy(() => import("../Component/Accounts/FeesStructure"));
const PaymentHistory = lazy(
  () => import("../Component/Accounts/PaymentHistory"),
);
const PaymentOptions = lazy(
  () => import("../Component/Accounts/PaymentOptions"),
);
const ManagePurchase = lazy(
  () => import("../Component/Accounts/Purchase/ManagePurchase"),
);

const ExpenseEntry = lazy(
  () => import("../Component/Accounts/Expenses/ExpenseEntry"),
);
const Ledger = lazy(() => import("../Component/Accounts/Ledger"));
const VerifyStudent = lazy(() => import("../Component/Students/VerifyStudent"));
export default function Routing({ userRights, setUserRights }) {
  let elements = useRoutes([
    {
      path: "/",
      element: <Login setUserRights={setUserRights} />,
    },
    {
      path: "unauthorized",
      element: <Unauthorized />,
    },
    {
      path: "home",
      element: (
        <ProtectedRoute
          element={<Home />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "Chairman",
            "HR Executive",
            "Recruiter",
            "Principal",
            "AdminExecutive",
            "Accounts",
            "Teaching",
            "SuperAdmin",
            "Auditor"
          ]}
        />
      ),
    },
    {
      path: "chairman",
      element: (
        <ProtectedRoute
          element={<ChairmanDashboard />}
          rights={userRights}
          allowedRights={["Chairman", "SuperAdmin"]}
        />
      ),
    },

    {
      path: "enquiry_form",
      element: (
        <ProtectedRoute
          element={<EnquiryForm />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "SuperAdmin",
            "Chairman",
            "HR Executive",
            "Recruiter",
            "Principal",
            "AdminExecutive",
            "Accounts",
          ]}
        />
      ),
    },

    {
      path: "admission_form",
      element: (
        <ProtectedRoute
          element={<AdmissionForm />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "SuperAdmin",
            "Chairman",
            "HR Executive",
            "Recruiter",
            "Principal",
            "Accounts",
            "AdminExecutive",
            "Student",
          ]}
        />
      ),
      // children: [{ path: "", element: <CandidateRecruitmentForm /> }],
      //OfficeAutomationDashboard
    },
    //<Route path="/student/edit/:id" element={<AdmissionForm />} />
    {
      path: "/student/edit/:id",
      element: (
        <ProtectedRoute
          element={<AdmissionForm />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "Chairman",
            "HR Executive",
            "Recruiter",
            "Principal",
            "AdminExecutive",
            "Accounts",
            "Teaching",
            "SuperAdmin",
          ]}
        />
      ),
      // children: [{ path: "", element: <CandidateRecruitmentForm /> }], store
      //OfficeAutomationDashboard
    },
    {
      path: "/student/view/:id",
      element: (
        <ProtectedRoute
          element={<AdmissionForm />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "Chairman",
            "HR Executive",
            "Recruiter",
            "Accounts",
            "Principal",
            "AdminExecutive",
            "Teaching",
            "SuperAdmin",
          ]}
        />
      ),
      // children: [{ path: "", element: <CandidateRecruitmentForm /> }],
      //OfficeAutomationDashboard
    },
    {
      path: "/verify/student/:id",
      element: <VerifyStudent />,
      // children: [{ path: "", element: <CandidateRecruitmentForm /> }],
      //OfficeAutomationDashboard
    },
    {
      path: "fee_receipt",
      element: (
        <ProtectedRoute
          element={<FeeReceipt />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "SuperAdmin",
            "Chairman",
            "HR Executive",
            "Recruiter",
            "Accounts",
          ]}
        />
      ),
    },
    {
      path: "student_list",
      element: (
        <ProtectedRoute
          element={<StudentList />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "SuperAdmin",
            "Chairman",
            "HR Executive",
            "Recruiter",
            "Principal",
            "Accounts",
            "AdminExecutive",
            "Teaching",
          ]}
        />
      ),
    },
     {
      path: "admissions_trash",
      element: (
        <ProtectedRoute
          element={<TrashAdmissions />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "SuperAdmin",
            "Chairman",
            "HR Executive",          
            "Principal",
            "Accounts",
            "AdminExecutive", 
          ]}
        />
      ),
    },
    {
      path: "/trash/student-details/:studentId",
      element: <StudentTrashDetails />
    },
    {
      path: "fee-summary",
      element: (
        <ProtectedRoute
          element={<FeeSummary />}
          rights={userRights}
          allowedRights={["Admin", "SuperAdmin", "Chairman", "Accounts","Auditor"]}
        />
      ),
    },
    {
      path: "principal_dashboard",
      element: (
        <ProtectedRoute
          element={<PrincipalDashboard />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "SuperAdmin",
            "Chairman",
            "HR Executive",
            "Recruiter",
            "Principal",
          ]}
        />
      ),
    },
    {
      path: "principal_reports",
      element: (
        <ProtectedRoute
          element={<ViewReports />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "SuperAdmin",
            "Chairman",
            "HR Executive",
            "Recruiter",
            "Principal",
          ]}
        />
      ),
    },
    {
      path: "eventscheduler",
      element: (
        <ProtectedRoute
          element={<EventScheduler />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "SuperAdmin",
            "Chairman",
            "HR Executive",
            "Recruiter",
            "Principal",
            "Accounts",
            "Teaching",
          ]}
        />
      ),
    },
    {
      path: "sms_alerts",
      element: (
        <ProtectedRoute
          element={<SmsAlerts />}
          rights={userRights}
          allowedRights={["Admin", "Chairman", "Accountant", "SuperAdmin"]}
        />
      ),
    },
    {
      path: "employee-list",
      element: (
        <ProtectedRoute
          element={<EmployeeList />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "SuperAdmin",
            "Chairman",
            "HR Executive",
            "Principal",
            "Accounts",
          ]}
        />
      ),
    },
    {
      path: "hostel_management",
      element: (
        <ProtectedRoute
          element={<HostelManagement />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "SuperAdmin",
            "Chairman",
            "HR Executive",
            "Recruiter",
            "Warden",
          ]}
        />
      ),
    },
    {
      path: "accounts_management",
      element: (
        <ProtectedRoute
          element={<AccountsManagement />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "SuperAdmin",
            "Chairman",
            "HR Executive",
            "Recruiter",
            "Accounts",
          ]}
        />
      ),
    },
    {
      path: "invoice_list",
      element: (
        <ProtectedRoute
          element={<InvoiceList />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "SuperAdmin",
            "Chairman",
            "HR Executive",
            "Recruiter",
            "Accounts",
          ]}
        />
      ),
    },

    {
      path: "purchase_management",
      element: (
        <ProtectedRoute
          element={<ManagePurchase />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "Chairman",
            "Accounts",
            "SuperAdmin",
            "AdminExecutive",
            "Accounts",
            "Auditor"
          ]}
        />
      ),
    },
    {
      path: "fees_management",
      element: (
        <ProtectedRoute
          element={<FeesManagement />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "SuperAdmin",
            "Chairman",
            "HR Executive",
            "Recruiter",
            "Accounts",
          ]}
        />
      ),
    },
    {
      path: "generate-bills",
      element: (
        <ProtectedRoute
          element={<GenerateInvoice />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "SuperAdmin",
            "Chairman",
            "HR Executive",
            "Recruiter",
            "Accounts",
          ]}
        />
      ),
    },
    {
      path: "generate-bills/view/:id",
      element: (
        <ProtectedRoute
          element={<GenerateInvoice />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "SuperAdmin",
            "Chairman",
            "HR Executive",
            "Recruiter",
            "Accounts",
            "AdminExecutive",
          ]}
        />
      ),
    },
    {
      path: "fees-structure",
      element: (
        <ProtectedRoute
          element={<FeesStructure />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "SuperAdmin",
            "Chairman",
            "HR Executive",
            "Recruiter",
            "Accounts",
          ]}
        />
      ),
    },
    {
      path: "fee-structure-list",
      element: (
        <ProtectedRoute
          element={<FeesStructureList />}
          rights={userRights}
          allowedRights={["Admin", "Chairman", "Accounts", "SuperAdmin"]}
        />
      ),
    },
    {
      path: "collect-payments",
      element: (
        <ProtectedRoute
          element={<PaymentOptions />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "SuperAdmin",
            "Chairman",
            "HR Executive",
            "Recruiter",
            "Accounts",
            "SuperAdmin",
          ]}
        />
      ),
    },
    {
      path: "payment-history",
      element: (
        <ProtectedRoute
          element={<PaymentHistory />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "SuperAdmin",
            "SuperAdmin",
            "Chairman",
            "HR Executive",
            "Recruiter",
            "Accounts",
          ]}
        />
      ),
    },
    {
      path: "admin_dashboard",
      element: (
        <ProtectedRoute
          element={<AdminDashboard />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "SuperAdmin",
            "HR",
            "HR Executive",
            "Recruiter",
            "Chairman",
            "Accounts",
          ]}
        />
      ),
    },
    //inventory_form

    {
      path: "store-admin",
      element: (
        <ProtectedRoute
          element={<AdminPage />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "SuperAdmin",
            "Chairman",
            "HR Executive",
            "Recruiter",
            "Principal",
            "AdminExecutive",
            "Accounts",
          ]}
        />
      ),
      children: [
        { path: "", element: <StockManagementPage /> },
        { path: "sku", element: <StockManagementPage /> },
        { path: "purchase", element: <Purchase /> },
        { path: "suppliers", element: <Suppliers /> },
        { path: "consume", element: <Consumption /> },
        { path: "rtn-purchase", element: <PurchaseReturns /> },
      ],
      //OfficeAutomationDashboard
    },
    {
      path: "fee_structure_letter",
      element: (
        <ProtectedRoute
          element={<LettersComponent />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "SuperAdmin",
            "HR",
            "HR Executive",
            "Chairman",
            "Principal",
            "Accounts",
          ]}
        />
      ),
    },
    {
      path: "id-card",
      element: (
        <ProtectedRoute
          element={<IDCard />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "SuperAdmin",
            "HR",
            "HR Executive",
            "Recruiter",
            "Chairman",
            "Principal",
            "Accounts",
          ]}
        />
      ),
    },
    {
      path: "admin-id-card",
      element: (
        <ProtectedRoute
          element={<AdminIDCard />}
          rights={userRights}
          allowedRights={["Admin", "SuperAdmin"]}
        />
      ),
    },
    {
      path: "accounts_dashboard",
      element: (
        <ProtectedRoute
          element={<AccountsDashboard />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "SuperAdmin",
            "HR",
            "HR Executive",
            "Recruiter",
            "Chairman",
            "Accounts",
            "Auditor"
          ]}
        />
      ),
    },
    {
      path: "dashboard",
      element: (
        <ProtectedRoute
          element={<OfficeAutomationDashboard />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "SuperAdmin",
            "HR",
            "HR Executive",
            "Recruiter",
            "Chairman",
          ]}
        />
      ),
    },
    {
      path: "emp-management",
      element: (
        <ProtectedRoute
          element={<EmployeeManagement />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "SuperAdmin",
            "HR",
            "HR Executive",
            "Recruiter",
            "Chairman",
            "Accounts",
          ]}
        />
      ),
    },
    {
      path: "attendance",
      element: (
        <ProtectedRoute
          element={<AttendanceForm />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "SuperAdmin",
            "HR",
            "HR Executive",
            "Recruiter",
            "Chairman",
            "AdminExecutive",
            "Teaching",
          ]}
        />
      ),
    },
    {
      path: "attendance-2",
      element: (
        <ProtectedRoute
          element={<RegisterFace />}
          rights={userRights}
          allowedRights={["Admin", "AdminExecutive", "SuperAdmin", "Teaching"]}
        />
      ),
    },
    {
      path: "attendance-camera",
      element: (
        <ProtectedRoute
          element={<AttendanceCamera />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "SuperAdmin",
            "HR",
            "HR Executive",
            "Recruiter",
            "Chairman",
            "AdminExecutive",
            "Student",
            "Teaching",
          ]}
        />
      ),
    },
    {
      path: "mark-manual-attendance",
      element: (
        <ProtectedRoute
          element={<ManualAttendanceForm />}
          rights={userRights}
          allowedRights={[
            "Principal",
            "Admin",
            "SuperAdmin",
            "HR",
            "HR Executive",
            "Chairman",
            "AdminExecutive",
            "Teaching",
          ]}
        />
      ),
    },

    {
      path: "liveness-settings",
      element: (
        <ProtectedRoute
          element={<LivenessSettingsAdmin />}
          rights={userRights}
          allowedRights={["Admin", "SuperAdmin"]}
        />
      ),
    },
    {
      path: "student_attendance",
      element: (
        <ProtectedRoute
          element={<StudentAttendance />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "SuperAdmin",
            "HR",
            "HR Executive",
            "Recruiter",
            "Chairman",
            "AdminExecutive",
            "Student",
            "Teaching",
          ]}
        />
      ),
    },
    {
      path: "student_attendance_list",
      element: (
        <ProtectedRoute
          element={<StudentAttendanceList />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "SuperAdmin",
            "HR",
            "HR Executive",
            "Recruiter",
            "Chairman",
            "AdminExecutive",
            "Principal",
            "Student",
            "Teaching",
          ]}
        />
      ),
    },
    {
      path: "employees_attendance_list",
      element: (
        <ProtectedRoute
          element={<EmployeesAttendanceList />}
          rights={userRights}
          allowedRights={[
            "SuperAdmin",
            "HR",
            "HR Executive",
            "Recruiter",
            "Chairman",
            "Principal",
            "Teaching",
            "Admin"
          ]}
        />
      ),
    },
    {
      path: "leave-management",
      element: (
        <ProtectedRoute
          element={<LeaveManagement />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "SuperAdmin",
            "HR",
            "HR Executive",
            "Recruiter",
            "Chairman",
          ]}
        />
      ),
    },
    {
      path: "payroll",
      element: (
        <ProtectedRoute
          element={<PayrollProcessing />}
          rights={userRights}
          allowedRights={[
            "SuperAdmin",
            "HR",
            "HR Executive",
            "Chairman",
            "Accounts",
            "Auditor"
          ]}
        />
      ),
    },
    {
      path: "payslip",
      element: (
        <ProtectedRoute
          element={<PaySlip />}
          rights={userRights}
          allowedRights={[
            "SuperAdmin",
            "HR",
            "HR Executive",
            "Recruiter",
            "Chairman",
            "Accounts",
            "Auditor"
          ]}
        />
      ),
    },
    {
      path: "paysliplist",
      element: (
        <ProtectedRoute
          element={<PaySlipList />}
          rights={userRights}
          allowedRights={["HR", "Chairman", "Accounts", "SuperAdmin","Auditot"]}
        />
      ),
    },
    {
      path: "letter",
      element: (
        <ProtectedRoute
          element={<LettersComponent />}
          rights={userRights}
          allowedRights={["Admin", "HR", "Chairman", "Recruiter", "SuperAdmin"]}
        />
      ),
    },
    {
      path: "certificate",
      element: (
        <ProtectedRoute
          element={<CertificateGenerator />}
          rights={userRights}
          allowedRights={["Admin", "HR", "Chairman", "Recruiter", "SuperAdmin"]}
        />
      ),
    },
    {
      path: "teacher_dashboard",
      element: (
        <ProtectedRoute
          element={<TeacherDashboard />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "Chairman",
            "Teaching",
            "Principal",
            "SuperAdmin",
          ]}
        />
      ),
    },
    {
      path: "download_backup",
      element: (
        <ProtectedRoute
          element={<BackupDownloadComponent />}
          rights={userRights}
          allowedRights={["Admin"]}
        />
      ),
    },
    {
      path: "expense-entry",
      element: (
        <ProtectedRoute
          element={<ExpenseEntry />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "AdminExecutive",
            "SuperAdmin",
            "Accounts",
            "Chairman",
          ]}
        />
      ),
    },
    {
      path: "welcome-letter",
      element: <WelcomeLetter />,
    },
    //ReportInfo
    {
      path: "reporting-info",
      element: <ReportInfo />,
    },
    {
      path: "library",
      element: (
        <ProtectedRoute
          element={
            <Suspense fallback={<div>Component1 is loading...</div>}>
              <AdminLayout />
            </Suspense>
          }
          rights={userRights}
          allowedRights={[
            "Admin",
            "Accounts",
            "Manager",
            "Reception",
            "AdminExecutive",
            "SuperAdmin",
            "Chairman",
          ]}
        />
      ),
      children: [
        {
          path: "",
          element: (
            <ProtectedRoute
              element={
                <Suspense fallback={<div>Component1 is loading...</div>}>
                  <AdminPageLibrary />
                </Suspense>
              }
              rights={userRights}
              allowedRights={[
                "Chairman",
                "Admin",
                "SuperAdmin",
                "Accounts",
                "Manager",
                "Teacher",
                "Principal",
              ]}
            />
          ),
        },
        {
          path: "dashboard",
          element: (
            <ProtectedRoute
              element={
                <Suspense fallback={<div>Component1 is loading...</div>}>
                  <AdminPageLibrary />
                </Suspense>
              }
              rights={userRights}
              allowedRights={[
                "Chairman",
                "Admin",
                "SuperAdmin",
                "Accounts",
                "Manager",
                "Teacher",
                "Principal",
              ]}
            />
          ),
        },
        {
          path: "books", //  "/library_member",
          element: (
            <ProtectedRoute
              element={
                <Suspense fallback={<div>Component1 is loading...</div>}>
                  <AdminBooksPage />
                </Suspense>
              }
              rights={userRights}
              allowedRights={[
                "Admin",
                "SuperAdmin",
                "Accounts",
                "Manager",
                "Reception",
                "Subscriber",
              ]}
            />
          ),
        },
        {
          path: "rentals",
          element: (
            <ProtectedRoute
              element={
                <Suspense fallback={<div>Component1 is loading...</div>}>
                  <BooksRentalList />
                </Suspense>
              }
              rights={userRights}
              allowedRights={[
                "Admin",
                "SuperAdmin",
                "Accounts",
                "Manager",
                "Reception",
              ]}
            />
          ),
        },
      ],
    },
    {
      path: "headcount",
      element: (
        <ProtectedRoute
          element={
            <Suspense fallback={<div>Component1 is loading...</div>}>
              <HostelForm />
            </Suspense>
          }
          rights={userRights}
          allowedRights={[
            "Admin",
            "SuperAdmin",
            "Accounts",
            "Manager",
            "Reception",
            "Warden",
          ]}
        />
      ),
    },
    {
      path: "ledger",
      element: (
        <ProtectedRoute
          element={
            <Suspense fallback={<div>Component1 is loading...</div>}>
              <Ledger />
            </Suspense>
          }
          rights={userRights}
          allowedRights={["Admin", "SuperAdmin", "Accounts", "Chairman"]}
        />
      ),
    },
    {
      path: "journal",
      element: (
        <ProtectedRoute
          element={
            <Suspense fallback={<div>Component1 is loading...</div>}>
              <Journal />
            </Suspense>
          }
          rights={userRights}
          allowedRights={["Admin", "SuperAdmin", "Accounts", "Chairman"]}
        />
      ),
    },
    {
      path: "callcenter",
      element: (
        <ProtectedRoute
          element={
            <Suspense fallback={<div>Component1 is loading...</div>}>
              <CallLogEntry />
            </Suspense>
          }
          rights={userRights}
          allowedRights={[
            "Admin",
            "SuperAdmin",
            "Accounts",
            "Manager",
            "Reception",
            "Warden",
          ]}
        />
      ),
    },
    {
      path: "support",
      element: <SupportPanel />,
    },
    {
      path: "UtilityManagement",
      element: (
        <ProtectedRoute
          element={<UtilityManagement />}
          rights={userRights}
          allowedRights={["Admin", "SuperAdmin", "Chairman", "Accounts"]}
        />
      ),
    },
    {
      path: "qr-code-generator",
      element: (
        <ProtectedRoute
          element={<QRCodeGenerator />}
          rights={userRights}
          allowedRights={["Admin", "SuperAdmin", "Chairman", "Accounts"]}
        />
      ),
    },
  ]);

  return <Suspense fallback={<div>Loading...</div>}>{elements}</Suspense>;
}
